import { useEffect, useMemo } from "react";
import { useAppSelector, useAppDispatch } from "redux/hooks";
import ComboBoxRedux from "components/molecules/ComboBoxRedux";
import { change } from "redux-form";
import AssetManagementService from "services/assetManagement.service";

export default function SelectAssetSubCategory(props: any) {
    const dispatch = useAppDispatch();
    const handoverData = useAppSelector((state) => state.assetManagement.handoverData) as any[];
    const formName = props.componentProps?.form || props.form || "AddAssetForm";
    const category = useAppSelector((state) => state.form?.[formName]?.values?.category_id);
    const handoverFilters = useAppSelector((s) => s.assetManagement.handoverFilters);

    // Fetch handover data if not available
    useEffect(() => {
        AssetManagementService.getGroupedAssetsSelection({...handoverFilters,all:true});
    }, [handoverFilters]);

    const subcategoryOptions = useMemo(() => {
        if (!category) return [];
        
        // Handle multiple categories
        if (Array.isArray(category)) {
            const allSubcategories: any[] = [];
            category.forEach((cat: any) => {
                const categoryId = cat?.value || cat;
                const categoryName = cat?.label || cat?.name || "";
                const selectedCategory = handoverData.find((c: any) => c._id === categoryId);
                if (selectedCategory && selectedCategory.subcategories) {
                    const catLabel = categoryName || selectedCategory.name || "";
                    selectedCategory.subcategories.forEach((sub: any) => {
                        // Avoid duplicates
                        if (!allSubcategories.find((s: any) => s.value === sub._id)) {
                            allSubcategories.push({
                                label: catLabel ? `${catLabel} - ${sub.name}` : sub.name,
                                value: sub._id,
                            });
                        }
                    });
                }
            });
            return allSubcategories;
        }
        
        // Handle single category
        const categoryId = category?.value || category;
        const categoryName = category?.label || category?.name || "";
        const selectedCategory = handoverData.find((cat: any) => cat._id === categoryId);
        
        if (!selectedCategory || !selectedCategory.subcategories) return [];
        
        const catLabel = categoryName || selectedCategory.name || "";
        
        return selectedCategory.subcategories.map((sub: any) => ({
            label: catLabel ? `${catLabel} - ${sub.name}` : sub.name,
            value: sub._id,
        }));
    }, [category, handoverData]);

    // Reset subcategory when category changes
    useEffect(() => {
        if (category && formName) {
            dispatch(change(formName, "subcategory_id", null));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [category]);

    const multiple = props.ComboBoxProps?.multiple !== undefined ? props.ComboBoxProps.multiple : false;

    return (
        <ComboBoxRedux
            {...props}
            ComboBoxProps={{
                ...props.ComboBoxProps,
                multiple,
                disabled: !category || subcategoryOptions.length === 0,
            }}
            options={subcategoryOptions}
            loading={false}
        />
    );
}

